/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import noteReadView from '../paper-note-read-view';
import paperMoveToFolder from '../paper-move-to-folder';
import paperSharedToUser from '../paper-share-with-user-popup';
import pdfViewer from '../pdf-viewer';
import ppLeftSidebar from '../paperpile-left-sidebar';
import toast from '@/services/toast';
import trashPaperPopup from '../trash-paper-popup';
import updatePpDetails from '../update-paperpile-details';

export default {
  name: 'bucket-details',
  components: {
    'pp-left-sidebar' : ppLeftSidebar,
    'pdf-viewer' : pdfViewer,
    'update-pp-details' : updatePpDetails,
    'paper-move-to-folder':paperMoveToFolder,
    'note-read-view' : noteReadView,
    'paper-share':paperSharedToUser,
    'trash-paper-popup':trashPaperPopup,
  },
  props: ['bucketId'],
  data () {
    return {
      bucketDetails:null,
      checkBucketId:'',
      userLoading:false,
      pdf_is_fav:Boolean,
      pdfViewerPopup:false,
      pdfViewerUrl:'',
      pdfViewerFileName:'',
      updatePaperPileDetailPopupState:false,
      pdfId:'',
      paperMoverToFolder:false,
      paperMoverToFolderData:null,
      notesViewData:null,
      notesViewPopupState:false,
      paperUpdateInfo:null,
      sharedPaperState:false,
      sharedPaperInfo:null,
      trashPaperState:false,
      trashPaperId:'',
      selfUserInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'getBucketDetailByIdOfAwerackGetters',
      'acUserDetailsStateGetters'
    ]),
    getSelfUserDetailsFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getBucketDetailsFun(){
      this.bucketDetails = this.$store.getters.getBucketDetailByIdOfAwerackGetters.data;
      return
    },
  },
  mounted () {
    this.getSelfUserDetailsFun
    this.getBucketDetailsFun
    bus.$on('pdfViewerPopupBus', (data) => {
      this.pdfViewerPopup = data;
    });
    bus.$on('updatePaperPileDetailPopupStateBus', (data) => {
      this.updatePaperPileDetailPopupState = data;
    });
    bus.$on('paperMoverToFolderBus', (data) => {
      this.paperMoverToFolder = data;
    });
    bus.$on('notesViewPopupStateBus', (data) => {
      this.notesViewPopupState = data;
    });
    bus.$on('trashPaperStateBus', (data) => {
      this.trashPaperState = data;
    });
    bus.$on('sharedPaperBus', (data) => {
      this.sharedPaperState = data;
    });
  },
  methods: {
    paperSharedMethod(data){
      this.sharedPaperInfo = data.pdf_paper
      this.sharedPaperState = true
      $('body').addClass('body_right_scroll_remove')
    },
    trashPaperMethod(ID){
      this.trashPaperId = ID
      this.trashPaperState = true
      $('body').addClass('body_right_scroll_remove')
    },
    noteViewShowMethod(data){
      this.notesViewData = data
      this.notesViewPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    paperMoverToFolderMethod(data){
      this.paperMoverToFolderData = data.pdf_paper
      this.paperMoverToFolder = true
      $('body').addClass('body_right_scroll_remove')
    },
    backArrow(){
      return this.$router.go(-1)
    },
    pdfViewerFun(url, fileName, id){
      this.pdfId = id
      this.pdfViewerFileName = fileName
      this.pdfViewerUrl = url
      this.pdfViewerPopup = true
      $('body').addClass("pdf_view_actv")
    },
    openPopupOfAddPaperPile(){
      this.addPaperPilePopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    updatePpDetailMethod(data){
      this.paperUpdateInfo = data.pdf_paper
      this.updatePaperPileDetailPopupState = true
      $('body').addClass('body_right_scroll_remove')  
    },
    favOfPaperMethod(isFav, paperId){
      if(isFav == true){
        this.pdf_is_fav = false
      }else{
        this.pdf_is_fav = true
      }
      let data = {
        is_favourite : this.pdf_is_fav
      }
      this.$store.dispatch('updatePaperPileDetailsByIdFun', {data:{id:paperId,data:data}})
        .then((res) => {  
          toast.success(res.data.msg);
          this.getPaperPileInfoAgain()
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.msg);
      })
    },
    getPaperPileInfoAgain(){
      this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id:this.bucketId }).then((res) => {
      }).catch((err) => {
      })
    }
  },
  watch:{
    getSelfUserDetailsFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    getBucketDetailsFun(){
      return this.$store.getters.getBucketDetailByIdOfAwerackGetters
    },
    bucketId(new_val, old_val){
      this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id: new_val }).then((res) => {
      }).catch((err) => {
      })
    }
  },
  beforeCreate:function(){
    $('body').addClass('researchfile_body_wrp')
  },
  beforeRouteLeave: function(to, from, next) {
    if(to.name != 'awerackResearchGroup' && to.name != 'paperPilesPreferences'){
      $('body').removeClass('researchfile_body_wrp');
    }
    next();
  },
}